import { useSelector } from 'react-redux';

import { getCategoryBreadcrumbHierarchy } from './productsModule';

export default function useCategoryBreadcrumbHierarchy(categoryId) {
  return useSelector((state) =>
    getCategoryBreadcrumbHierarchy(state, categoryId)
  );
}
